<div style="margin: 0; padding: 0; width: 500px"

>
   <h4 *ngIf="isSlotWithSequence(slot)" class="text-center" mat-dialog-title>
      <img class="small-image-head"
           src="assets/images/calendar-64.png">&nbsp;&nbsp;&nbsp;{{slot.startTime | date: 'EEE d MMMM à h:mm'}}
   </h4>
   <div *ngIf="show" mat-dialog-content>
      <h1 class="card_title">
            {{ slot.label }}
            {{ slot.groupDate }}
      </h1>
      <div *ngIf="slot.price" class="row grid-input">
         <div class="col-md-5">
            <h5>
               {{traductionsKeysEnum.SPOT_PRICE | translate}}:
            </h5>
         </div>
         <div class="col-md-7 text-center">
            <div [style]="'--span: ' + '#F5F5F5'" class="card-span">
               <div style="flex: 3">{{slot.price}}€</div>
            </div>
         </div>
      </div>
      <div *ngIf="slot.channelName" class="row margeTop grid-input">
         <div class="col-md-5">
            <h5>
               {{traductionsKeysEnum.CHANNEL| translate}}:
            </h5>
         </div>
         <div class="col-md-7 text-center">
            <div [style]="'--span: ' + '#FFFFF0'" class="card-span">
               <div style="flex: 3">{{slot.channelName}}</div>
            </div>
         </div>
      </div>
      <ng-container [formGroup]="form">
         <div *ngIf="slot.duration" class="row margeTop grid-input">
            <div class="col-md-5">
               <h5>
                  {{traductionsKeysEnum.DURATION| translate}}:
               </h5>
            </div>
            <div class="col-md-7 text-center">
               <div [style]="'--span: ' + '#F5FFFA'" class="card-span">
                  <app-editable-input (updatedValue)="overrideSlot($event)"
                                      [displayValue]="duration"
                                      [formControlName]="'durationOver'"
                                      [updateValue]="slot.durationOver" formControlName="durationOver">
                  </app-editable-input>
               </div>
            </div>
         </div>
         <div class="row margeTop grid-input">
            <div class="col-md-5">
               <h5>
                  {{traductionsKeysEnum.NUMBER_OF_SPOTS| translate}}:
               </h5>
            </div>
            <div class="col-md-7 text-center">
               <div [style]="'--span: ' + '#F5FFFA'" class="card-span" editableGroup>
                  <app-editable-input (updatedValue)="overrideSlot($event)"
                                      [displayValue]="spotMaxNumber"
                                      [formControlName]="'spotMaxNumberOver'"
                                      [updateValue]="slot.spotMaxNumberOver"
                                      formControlName="spotMaxNumberOver">
                  </app-editable-input>
               </div>
            </div>
         </div>
         <div class="row margeTop grid-input">
            <div class="col-md-5">
               <h5>
                  {{traductionsKeysEnum.NUMBER_OF_SPOTS_FOR_TRAILERS| translate}}:
               </h5>
            </div>
            <div class="col-md-7 text-center">
               <div [style]="'--span: ' + '#F5FFFA'" class="card-span" editableGroup>
                  <app-editable-input (updatedValue)="overrideSlot($event)"
                                      [displayValue]="spotMaxNumberTrailer"
                                      [formControlName]="'spotMaxNumberTrailerOver'"
                                      [updateValue]="slot.spotMaxNumberTrailerOver"
                                      formControlName="spotMaxNumberTrailerOver">
                  </app-editable-input>
               </div>
            </div>
         </div>
         <div *ngIf="slot.plannerStatus" class="row margeTop grid-input">
            <div class="col-md-5">
               <h5>
                  {{traductionsKeysEnum.STATUS| translate}}:
               </h5>
            </div>
            <div class="col-md-7 text-center">
               <div [style]="'--span: ' + '#F5FFFA'" class="card-span">
                  <app-editable-input (updatedValue)="overrideSlot($event)"
                                      [displayValue]="plannerStatus"
                                      [formControlName]="'plannerStatusOver'"
                                      [updateValue]="slot.plannerStatusOver"
                                      formControlName="plannerStatusOver">
                  </app-editable-input>
               </div>
            </div>
         </div>
      </ng-container>
      <div *ngIf="isSlotWithSequence(slot) && slot.beforeShow" class="row margeTop grid-input">
         <div class="col-md-5">
            <h5>
               {{traductionsKeysEnum.BEFORE| translate}}:
            </h5>
         </div>
         <div class="col-md-7 text-center">
            <div [style]="'--span: ' + '#E0FFFF'" class="card-span">
               <div style="flex: 3">{{slot.beforeShow}}</div>
               <div class="icons">
                  <img class="small-image" src="assets/images/before.png">
                  <button class="btn-success btn-success1 btn-update" [title]="traductionsKeysEnum.MAJ| translate" type="button"><i
                     aria-hidden="true"
                     class="fa fa-edit"></i>
                  </button>
               </div>
            </div>
         </div>
      </div>
      <div *ngIf="isSlotWithSequence(slot) && slot.afterShow" class="row margeTop grid-input">
         <div class="col-md-5">
            <h5>
               {{traductionsKeysEnum.AFTER| translate}}:
            </h5>
         </div>
         <div class="col-md-7 text-center">
            <div [style]="'--span: ' + '#E6E6FA'" class="card-span">
               <div style="flex: 3">{{slot.afterShow}}</div>
               <div class="icons">
                  <img class="small-image" src="assets/images/after.png">
                  <button class="btn-success btn-success1 btn-update" [title]="traductionsKeysEnum.MAJ| translate" type="button"><i
                     aria-hidden="true"
                     class="fa fa-edit"></i>
                  </button>
               </div>
            </div>
         </div>
      </div>
      <div *ngIf="slot.usedRate" class="row margeTop grid-input">
         <div class="col-md-5">
            <h5>
               {{traductionsKeysEnum.RATE_USED | translate}}:
            </h5>
         </div>

         <div class="col-md-7 text-center">
            <div class="card-span-prog">
               <ng-container *ngIf="(slot.usedRate + slot.semiUsedRate) === 0; else sup0;">
                  <div class="text-center" style="border-radius: 5px;">
                     {{ round2(slot.usedRate + slot.semiUsedRate) + '%' }}
                  </div>
               </ng-container>
               <ng-template #sup0>
                  <div class="progress position-relative" style="border-radius: 5px; width: 100%;">
                     <div
                     [class]="(slot.usedRate) >= 1 ? 'progress-bar progress-bar-success' : 'progress-bar progress-bar-warning' "
                     [style]="(slot.usedRate+slot.semiUsedRate) > 1 ?'width:' + round2(calculUsedRate(slot.usedRate, slot.semiUsedRate)) + '%' : 'width:' + round2(slot.usedRate) + '%'" aria-valuemax="100"
                     aria-valuemin="0"
                     aria-valuenow="round2(slot.usedRate + slot.semiUsedRate)" role="progressbar"
                     style="padding: 0; margin: 0">
                     <small
                        style="left: 50%; position: center; color: #0a0a0a">{{ round2(slot.usedRate) + '%' }}</small>
                  </div>
                     <div
                     class="progress-bar bar-color"
                     [style]="(slot.usedRate+slot.semiUsedRate) > 1 ?'width:' + round2(calculSemiUsedRate(slot.usedRate, slot.semiUsedRate)) + '%' : 'width:' + round2(slot.semiUsedRate) + '%'" aria-valuemax="100"
                     aria-valuemin="0"
                     aria-valuenow="round2(slot.semiUsedRate)" role="progressbar"
                     style="padding: 0; margin: 0"
                     *ngIf="(slot.semiUsedRate) > 0"
                     >
                     <small
                        style="left: 50%; position: center; color: #0a0a0a">{{ round2(slot.semiUsedRate) + '%' }}</small>
                </div>
                  </div>
               </ng-template>
            </div>
         </div>

         <!-- <div class="col-md-7 text-center">
            <div class="card-span-prog">
               <ng-container *ngIf="(slot.usedRate + slot.semiUsedRate) === 0; else sup0;">
                  <div class="text-center" style="border-radius: 5px;">
                     {{ round2(slot.usedRate + slot.semiUsedRate) + '%' }}
                  </div>
               </ng-container>

               <ng-template #sup0>
                  <div class="progress position-relative" style="border-radius: 5px; width: 100%;">

                     <div
                        [class]="(slot.usedRate + slot.semiUsedRate) >= 1 ? 'progress-bar progress-bar-success' : 'progress-bar progress-bar-warning' "
                        [style]="'width:' + round2(slot.usedRate + slot.semiUsedRate) + '%'" aria-valuemax="100"
                        aria-valuemin="0"
                        aria-valuenow="round2(slot.usedRate + slot.semiUsedRate)" role="progressbar"
                        style="padding: 0; margin: 0">
                        <small
                           style="left: 50%; position: center; color: #0a0a0a">{{ round2(slot.usedRate + slot.semiUsedRate) + '%' }}</small>
                     </div>

                     <ng-container *ngIf="slot.usedRate === 0; else sup0;">
                        <div class="text-center" style="border-radius: 5px;">
                           {{round2(slot.usedRate) + '%'}}
                        </div>
                     </ng-container>

                     <div
                          class="progress-bar progress-bar-info"
                          [style]="'width:' + round2(slot.semiUsedRate) + '%'" aria-valuemax="100"
                          aria-valuemin="0"
                          aria-valuenow="round2(slot.semiUsedRate)" role="progressbar"
                          style="padding: 0; margin: 0">
                     </div>
                  </div>
               </ng-template>
            </div>
         </div> -->

      </div>
      <div *ngIf="slot.freeSpace" class="row margeTop grid-input">
         <div class="col-md-5">
            <h5>
               {{traductionsKeysEnum.FREE_SPACE| translate}}:
            </h5>
         </div>
         <div class="col-md-7 text-center">
            <div [style]="'--span: ' + '#FAEBD7'" class="card-span">
               {{slot.freeSpace + " " + slot.freeSpaceUnit}}
            </div>
         </div>
      </div>
      <div *ngIf="label" class="row margeTop grid-input">
         <div class="col-md-5">
            <h5>
               {{traductionsKeysEnum.MARKETING| translate}}
            </h5>
         </div>
         <div class="col-md-7 text-center">
            <div [style]="'--span: ' + '#A9A9A9'" class="card-span">
               {{label}}
            </div>
         </div>
      </div>
      <div *ngIf="isSlotWithSequence(slot) && slot.audienceForTarget && slot.audienceForTarget.grecGrp"
           class="row margeTop grid-input">
         <div class="col-md-5">
            <h5>
               Grp:
            </h5>
         </div>
         <div class="col-md-7 text-center">
            <div [style]="'--span: ' + '#FFF0F5'" class="card-span">
               {{slot.audienceForTarget.grecGrp.toFixed(2)}}
            </div>
         </div>
      </div>
      <div *ngIf="isSlotWithSequence(slot) && slot.audienceForTarget && slot.audienceForTarget.grecIndiceGrp"
           class="row margeTop grid-input">
         <div class="col-md-5">
            <h5>
               {{traductionsKeysEnum.GRP_INDEX| translate}}:
            </h5>
         </div>
         <div class="col-md-7 text-center">
            <div [style]="'--span: ' + '#B0E0E6'" class="card-span">
               {{slot.audienceForTarget.grecIndiceGrp.toFixed(2)}}
            </div>
         </div>
      </div>
      <div *ngIf="slot.indexedCgrp" class="row margeTop grid-input">
         <div class="col-md-5">
            <h5>
               {{traductionsKeysEnum.CGRP_GROSS| translate}}:
            </h5>
         </div>
         <div class="col-md-7 text-center">
            <div [style]="'--span: ' + 'thistle'" class="card-span">
               {{slot.indexedCgrp.toFixed(2)}}
            </div>
         </div>
      </div>

      <ng-container *ngIf="isSlotWithSequence(slot)">
         <h4 *ngIf="slot.sequences && slot.sequences.length > 0" class="text-center">
            <b>{{traductionsKeysEnum.SEQUENCES| translate}}</b>
         </h4>
         <ngb-accordion #acc="ngbAccordion" *ngIf="slot.sequences && slot.sequences.length > 0">
            <ngb-panel *ngFor="let sequence of slot.sequences">
               <ng-template class="text-center" ngbPanelTitle>
                  <div class="card-seq">
                     <span *ngIf="sequence.campaignName">{{sequence.campaignName}}</span>
                     <span *ngIf="sequence.trailerType">{{'(' + sequence.trailerType + ')'}}</span>
                     <span *ngIf="sequence.orderStatus">{{'(' + (orderStatusMap[sequence.orderStatus].shortLabel || sequence.orderStatus.slice(0, 3)) + ')'}}</span>
                  </div>
               </ng-template>
               <ng-template ngbPanelContent>
                  <div *ngIf="sequence.campaignName" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.CAMPAIGN_NAME| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.campaignName}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.campaignType" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.CAMPAIGN_TYPE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.campaignType}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.campaignCode" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.CAMPAIGN_CODE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.campaignCode}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.campaignStartDate" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.START_CAMPAIGN| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.campaignStartDate | date: 'EEE d MMMM à HH:mm'}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.campaignEndDate" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.END_CAMPAIGN| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.campaignEndDate | date: 'EEE d MMMM à HH:mm'}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.clientId" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.CUSTOMER_ID| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.clientId}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.clientName" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.CUSTOMER_NAME| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.clientName}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.creationDate" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.CREATION_DATE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.creationDate | date: 'EEE d MMMM à HH:mm'}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.slotStartTime" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.BROADCAST_DATE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.slotStartTime | date: 'EEEE d MMMM'}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.updateDate" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.MODIFICATION_DATE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.updateDate | date: 'EEE d MMMM à HH:mm'}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.codeCouplage" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.PAIRING_CODE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.codeCouplage}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.natureId" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.OF_NATURE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.natureId}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.natureAbrege" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.NATURE_ABBREVIATES| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.natureAbrege}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.numNature" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.NATURE_NUMBER| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.numNature}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.preferencePos" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.PREFERENCE_POS| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.preferencePos}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.preferenceType" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.PREFERENCE_TYPE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.preferenceType}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.spotDuration" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.SPOT_DURATION| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.spotDuration + ' s'}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.spotCodeSecteur" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.SECTOR_SPOT_CODE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.spotCodeSecteur}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.status" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.STATUT| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.status}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.diffusionAttribute" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.BROADCAST_ATTRIBUTE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{ sequence.diffusionAttribute }}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.diffusionStatusLabel" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.BROADCAST_STATUS| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.diffusionStatusLabel}}
                        </div>
                     </div>
                  </div>
                  <div *ngIf="sequence.codeSecteurs" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.SECTOR_CODE| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.codeSecteurs}}
                        </div>
                     </div>
                  </div>

                  <div *ngIf="sequence.technicalStatus" class="row margeTopSM">
                     <div class="col-md-5">
                        <h5>
                           {{traductionsKeysEnum.TECHNICAL_CONDITION| translate}}:
                        </h5>
                     </div>
                     <div class="col-md-7 text-center">
                        <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                           {{sequence.technicalStatus}}
                        </div>
                     </div>
                  </div>
               </ng-template>
            </ngb-panel>
         </ngb-accordion>
      </ng-container>
      <ng-container *ngIf="isSlotGroupWithSequence(slot)">
         <h4 *ngIf="slot.sequenceGroups?.length > 0" class="text-center" style="display: flex;
            justify-content: center;
            gap: 10px;">
            <b>{{traductionsKeysEnum.GROUP_SEQUENCES| translate}}</b>
         </h4>
         <ng-container *ngFor="let sequenceGroup of slot.sequenceGroups">
            <ngb-accordion #acc="ngbAccordion">
               <ngb-panel>
                  <ng-template class="text-center" ngbPanelTitle>
                     <div class="card-seq">
                        <span *ngIf="sequenceGroup.campaignName">{{sequenceGroup.campaignName}}</span>
                        <span *ngIf="sequenceGroup.sequenceCount">{{'(' + sequenceGroup.sequenceCount + ')'}}</span>
                        <span *ngIf="sequenceGroup.trailerType">{{'(' + sequenceGroup.trailerType + ')'}}</span>
                        <span *ngIf="sequenceGroup.orderStatus">{{'(' + (orderStatusMap[sequenceGroup.orderStatus].shortLabel || sequenceGroup.orderStatus.slice(0, 3)) + ')'}}</span>
                        <span *ngIf="sequenceGroup.campaignPrice">{{'(' + sequenceGroup.campaignPrice + ')'}}</span>
                        <div *ngIf="sequenceGroup.status =='00:Option'">
                           <img src="assets/icons/sablier.png" style="width: 20px; height: auto;">
                        </div>
                     </div>
                  </ng-template>
                  <ng-template ngbPanelContent>
                     <div *ngIf="sequenceGroup.campaignName" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.CAMPAIGN_NAME| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.campaignName}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.campaignType" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.CAMPAIGN_TYPE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.campaignType}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.campaignCode" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.CAMPAIGN_CODE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.campaignCode}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.campaignPrice" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.CAMPAIGN_PRICE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.campaignPrice}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.campaignStartDate" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.START_CAMPAIGN| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.campaignStartDate | date: 'EEE d MMMM à HH:mm'}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.campaignEndDate" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.END_CAMPAIGN| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.campaignEndDate | date: 'EEE d MMMM à HH:mm'}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.clientId" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.CUSTOMER_ID| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.clientId}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.clientName" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.CUSTOMER_NAME| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.clientName}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.creationDate" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.CREATION_DATE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.creationDate | date: 'EEE d MMMM à HH:mm'}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.updateDate" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.MODIFICATION_DATE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.updateDate | date: 'EEE d MMMM à HH:mm'}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.codeCouplage" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.PAIRING_CODE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.codeCouplage}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.natureId" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.OF_NATURE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.natureId}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.natureAbrege" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.NATURE_ABBREVIATES| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.natureAbrege}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.numNature" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.NATURE_NUMBER| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.numNature}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.preferencePos" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.PREFERENCE_POS| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.preferencePos}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.preferenceType" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.PREFERENCE_TYPE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.preferenceType}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.spotDuration" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.SPOT_DURATION| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.spotDuration + ' s'}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.codeSecteurs" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.SECTOR_SPOT_CODE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.codeSecteurs}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.status" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.STATUT| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.status}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.orderStatus" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.ORDER_STATUS| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{ orderStatusMap[sequenceGroup.orderStatus]?.label }}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.diffusionAttribute" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.BROADCAST_ATTRIBUTE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.diffusionAttribute}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.diffusionStatusLabel" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.BROADCAST_STATUS| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.diffusionStatusLabel}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.codeSecteurs" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.SECTOR_CODE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.codeSecteurs}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.technicalStatus" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.TECHNICAL_CONDITION| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.technicalStatus}}
                           </div>
                        </div>
                     </div>
                     <div *ngIf="sequenceGroup.trailerType" class="row margeTopSM">
                        <div class="col-md-5">
                           <h5>
                              {{traductionsKeysEnum.TRAILER_TYPE| translate}}:
                           </h5>
                        </div>
                        <div class="col-md-7 text-center">
                           <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                              {{sequenceGroup.trailerType}}
                           </div>
                        </div>
                     </div>
                     <h4 *ngIf="sequenceGroup.sequences && sequenceGroup.sequences.length > 0"
                         class="text-center">
                        <b>{{traductionsKeysEnum.SEQUENCES| translate}} ({{sequenceGroup.sequenceCount}})</b>
                     </h4>
                     <ng-container *ngFor="let sequence of sequenceGroup.sequences">
                        <ngb-accordion #acc="ngbAccordion">
                           <ngb-panel>
                              <ng-template class="text-center" ngbPanelTitle>
                                 <div class="card-seq">
                                    <b>{{sequence.campaignName}}</b> -
                                    <b>{{sequence.slotStartTime | date : 'dd/MM/yyyy'}}</b>
                                 </div>
                              </ng-template>
                              <ng-template ngbPanelContent>
                                 <div *ngIf="sequence.campaignName" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.CAMPAIGN_NAME| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.campaignName}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.campaignType" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.CAMPAIGN_TYPE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.campaignType}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.campaignCode" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.CAMPAIGN_CODE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.campaignCode}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.campaignStartDate" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.START_CAMPAIGN| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.campaignStartDate | date: 'EEE d MMMM à HH:mm'}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.campaignEndDate" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.END_CAMPAIGN| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.campaignEndDate | date: 'EEE d MMMM à HH:mm'}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.clientId" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.CUSTOMER_ID| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.clientId}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.clientName" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.CUSTOMER_NAME| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.clientName}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.creationDate" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.CREATION_DATE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.creationDate | date: 'EEE d MMMM à HH:mm'}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.slotStartTime" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.BROADCAST_DATE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.slotStartTime | date: 'EEEE d MMMM'}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.updateDate" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.MODIFICATION_DATE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.updateDate | date: 'EEE d MMMM à HH:mm'}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.codeCouplage" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.PAIRING_CODE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.codeCouplage}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.natureId" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.OF_NATURE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.natureId}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.natureAbrege" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.NATURE_ABBREVIATES| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.natureAbrege}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.numNature" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.NATURE_NUMBER| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.numNature}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.preferencePos" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.PREFERENCE_POS| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.preferencePos}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.preferenceType" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.PREFERENCE_TYPE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.preferenceType}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.spotDuration" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.SPOT_DURATION| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.spotDuration + ' s'}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.spotCodeSecteur" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.SECTOR_SPOT_CODE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.spotCodeSecteur}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.status" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.STATUT| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.status}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.orderStatus" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.ORDER_STATUS| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{ orderStatusMap[sequence.orderStatus]?.label }}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.diffusionStatusLabel" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.BROADCAST_STATUS| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{ sequence.diffusionStatusLabel }}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.codeSecteurs" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.SECTOR_CODE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.codeSecteurs}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.technicalStatus" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.TECHNICAL_CONDITION| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequence.technicalStatus}}
                                       </div>
                                    </div>
                                 </div>
                                 <div *ngIf="sequence.trailerType" class="row margeTopSM">
                                    <div class="col-md-5">
                                       <h5>
                                          {{traductionsKeysEnum.TRAILER_TYPE| translate}}:
                                       </h5>
                                    </div>
                                    <div class="col-md-7 text-center">
                                       <div [style]="'--span: ' + '#FFFAFA'" class="card-span">
                                          {{sequenceGroup.trailerType}}
                                       </div>
                                    </div>
                                 </div>
                              </ng-template>
                           </ngb-panel>
                        </ngb-accordion>
                     </ng-container>
                  </ng-template>
               </ngb-panel>
            </ngb-accordion>
         </ng-container>
      </ng-container>
   </div>
   <div align="center" mat-dialog-actions>
      <button (click)="closeDialog()" class="btn btn-sm" mat-dialog-close mat-raised-button
              tabindex="-1">{{closeButtonText}}</button>
   </div>
</div>
